import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query'
import React, { StrictMode, Suspense } from 'react';
import Clarity from '@microsoft/clarity';

import {
    Main,
    Onboarding,
    Home,
    Search,
    Interested,
    Recieved,
    Send,
    Profile,
    Accepted,
    Declined,
    Favourite,
    Notifications,
    Subscription,
    CreateHoroscope,
    SuccessStories,
    IgnoredProfiles,
    Deactivate,
    ProfileView,
    TermsConditions,
    PrivacyPolicy,
    RefundPolicy,
    ActivePlan,
    Login,
    PaymentHistory,
    PaymentStatus,
    AccountDelete,
    Maintenance,
    ContactUs,
} from './screens';
import {
    MainLayout,
    MainMenuLayout,
    HomeLayout,
} from "./layout"
import { PageNotFound } from './components';
import ProtectedRoute from './middleware/ProtectedRoute';
import { useOneSignal } from './hooks/useOneSignal';
import ProtectedMainRoute from './middleware/ProtectedMainRoute';

export default function App() {

    const queryClient = new QueryClient();

    useOneSignal()
    
    React.useEffect(() => {
        const clarityAppId = import.meta.env.VITE_CLARITY_APPID
        if (!clarityAppId) {
            throw new Error("Clarity App Id needed")
        }

        Clarity.init(clarityAppId)
    }, [])

    return (
        <StrictMode>
            <QueryClientProvider client={queryClient} >
                <BrowserRouter>
                    <Suspense fallback={
                        <div className="flex items-center justify-center min-h-screen">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                        </div>
                    }>
                        <ProtectedMainRoute>
                            <Routes>
                                <Route path='/maintenance' element={<Maintenance />} />
                                <Route path='/' element={<MainLayout />}>
                                    <Route path="" element={<Main />}>
                                        {/* Login route as a nested route of Main */}
                                        <Route path="login" element={<Login />} />
                                    </Route>
                                    <Route path='terms-conditions' element={<TermsConditions />} />
                                    <Route path='privacy-policy' element={<PrivacyPolicy />} />
                                    <Route path='refund-policy' element={<RefundPolicy />} />
                                    <Route path='contact-us' element={<ContactUs />} />
                                    <Route path='deactivate' element={<Deactivate />} />
                                    <Route path='remove-account' element={<AccountDelete />} />

                                    <Route element={<ProtectedRoute />}>
                                        <Route path='onboarding' element={<Onboarding />} />
                                        <Route path='home' element={<HomeLayout />}>
                                            <Route path='' element={<MainMenuLayout />}>
                                                <Route path='' element={<Home />} />
                                                <Route path='search' element={<Search />} />
                                                <Route path='interested' element={<Interested />}>
                                                    <Route path='' element={<Recieved />} />
                                                    <Route path='send' element={<Send />} />
                                                    <Route path='accepted' element={<Accepted />} />
                                                    <Route path='declined' element={<Declined />} />
                                                </Route>
                                                <Route path='favourite' element={<Favourite />} />
                                                <Route path='notifications' element={<Notifications />} />
                                            </Route>
                                            <Route path='profile' element={<Profile />} />
                                            <Route path='profile/:userId' element={<ProfileView />} />
                                            <Route path='subscription' element={<Subscription />} />
                                            <Route path='active-plan' element={<ActivePlan />} />
                                            <Route path='create-horoscope' element={<CreateHoroscope />} />
                                            <Route path='checkout' element={<PaymentHistory />} />
                                            <Route path='checkout/status/:merchantOrderId' element={<PaymentStatus />} />
                                            <Route path='success-stories' element={<SuccessStories />} />
                                            <Route path='ignored-profiles' element={<IgnoredProfiles />} />
                                            <Route path='remove-account' element={<AccountDelete />} />
                                        </Route>
                                    </Route>
                                    <Route path='*' element={<PageNotFound />} />
                                </Route>
                            </Routes>
                        </ProtectedMainRoute>
                    </Suspense>
                </BrowserRouter>
            </QueryClientProvider>
        </StrictMode>
    )
}
